import React from 'react';

export default function AgentDetailKPIs({ data, loading, zeitraum, selectedDay, onDayClick }) {
  if (loading) {
    return (
      <div className="kpi-grid">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="kpi-card kpi-card--skeleton" />
        ))}
      </div>
    );
  }

  if (!data) return null;

const kpis = [
  {
    label: 'Tickets gesamt',
    value: data.gesamt,
    sub: 'im Zeitraum',
    color: 'neutral',
  },
  {
    label: 'Abgeschlossen',
    value: data.geloest,
    sub: `von ${data.gesamt} gesamt`,
    color: 'green',
  },
  {
    label: '\u00d8 Bearbeitungszeit',
    value: data.durchschnittFormatiert || '\u2013',
    sub: 'Business Hours',
    color: 'neutral',
  },
];

  const tage = Array.isArray(data.tage) ? data.tage : null;

  return (
    <>
      <div className="kpi-grid">
        {kpis.map(kpi => (
          <div key={kpi.label} className={`kpi-card kpi-card--${kpi.color}`}>
            <span className="kpi-label">{kpi.label}</span>
            <span className="kpi-value">{kpi.value}</span>
            <span className="kpi-sub">{kpi.sub}</span>
          </div>
        ))}
      </div>

      {/* Tages-Aufschluesselung (nur Wochen-Ansicht) — skaliert Mo..heute */}
      {tage && tage.length > 0 && (
        <div className="kpi-days">
          <div className="kpi-days-title">
            Pro Tag
            {selectedDay && (
              <button
                type="button"
                onClick={() => onDayClick && onDayClick(null)}
                style={{ marginLeft: 10, fontSize: 11, padding: '1px 8px', borderRadius: 4, border: '1px solid var(--border)', background: 'var(--bg-input)', color: 'var(--text-secondary)', cursor: 'pointer' }}
              >
                ✕ Alle Tage
              </button>
            )}
          </div>
          <div className="kpi-days-grid">
            {tage.map(t => {
              const isSelected = selectedDay === t.dayStr;
              const isClickable = !!onDayClick && t.gesamt > 0;
              return (
                <div
                  key={t.datum}
                  className={`kpi-day-card${isSelected ? ' kpi-day-card--active' : ''}`}
                  onClick={() => isClickable && onDayClick(isSelected ? null : t.dayStr)}
                  style={{ cursor: isClickable ? 'pointer' : 'default' }}
                  title={isClickable ? (isSelected ? 'Auswahl aufheben' : 'Tickets dieses Tages anzeigen') : undefined}
                >
                  <div className="kpi-day-head">
                    <span className="kpi-day-wd">{t.wochentag}</span>
                    <span className="kpi-day-date">{t.datum}</span>
                  </div>
                  <div className="kpi-day-row">
                    <span className="kpi-day-lbl">Tickets gesamt</span>
                    <span className="kpi-day-val">{t.gesamt}</span>
                  </div>
                  <div className="kpi-day-row">
                    <span className="kpi-day-lbl">Abgeschlossen</span>
                    <span className="kpi-day-val kpi-day-val--green">{t.geloest}</span>
                  </div>
                  <div className="kpi-day-row">
                    <span className="kpi-day-lbl">{'Ø'} Bearbeitungszeit</span>
                    <span className="kpi-day-val">{t.durchschnittFormatiert || '–'}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
